import React, { useState } from 'react';
import MonthlyFeesPage from './MonthlyFeesPage';
import PaymentsPage from './PaymentsPage';

/** /payments — «Сарын төлбөрийн бүртгэл» (тор) үндсэн таб + хуучин «Гүйлгээний түүх». */
export default function PaymentsHub() {
  const [tab, setTab] = useState<'grid' | 'history'>('grid');
  const t = (k: 'grid' | 'history'): React.CSSProperties => ({ padding: '9px 16px', borderRadius: 10, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14, background: tab === k ? '#236844' : '#eef1ee', color: tab === k ? '#fff' : '#3a4a41' });
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18, flexWrap: 'wrap' }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', margin: 0, flex: 1 }}>Төлбөр</h2>
        <button onClick={() => setTab('grid')} style={t('grid')}>Сарын төлбөрийн бүртгэл</button>
        <button onClick={() => setTab('history')} style={t('history')}>Гүйлгээний түүх</button>
      </div>
      {tab === 'grid' ? <MonthlyFeesPage /> : <PaymentsPage />}
    </div>
  );
}
